import SaveTagRequest from '../entities/SaveTagRequest'
import ITagPedagioRepository from '../repositories/ITagPedagioRepository'

export interface IsaveTag {
  execute(params: SaveTagRequest): Promise<void>
}

export default class SaveTagImpl implements IsaveTag {
  constructor(private readonly tagPedagioRepository: ITagPedagioRepository) {}

  public async execute(params: SaveTagRequest): Promise<void> {
    const response = await this.tagPedagioRepository.saveTag(params)
    return response
  }
}
